import { Post } from 'components/Post';

const Preview = () => <Post preview />;

export default Preview;
